module.exports = __webpack_public_path__ + "static/media/mar1.ffe04b58.jpg";